import * as types from "../constants/constants";
import { Postdata } from "../../helpers/api.service"
import HttpService from "../../helpers/httpServices"
import { message } from "./toastActions";
import { toast } from 'sonner'

export const verifyToken = () => {
  return async (dispatch) => {
    try {
      // Check if the token exists before verifying
      const token = window.localStorage.getItem("authorizationToken");
      if (!token) {
        dispatch(loginFail("Token missing"));
        return;
      }

      const result = await Postdata(HttpService.verifyTokenUrl, { token });
      if (result.status === 200) {
        dispatch(loginSuccess(result));
        console.log("Token verified successfully", result);
      } else {
        dispatch(loginFail(result.message));
        dispatch(loginForce());
      }
    } catch (e) {
      console.log("Error verifying token", e);
      dispatch(loginFail(e.message));
      dispatch(loginForce());
    }
  };
};

export const login = (data) => {
  return (dispatch) => {
    try {
      dispatch(loginInit());
      Postdata(HttpService.loginUrl, data).then(
        (result) => {
          if (result.status === 200) {
            toast.success(result.message || "Login successful");
            dispatch(loginSuccess(result));
          } else {
            // toast.error(result.message || "Login failed");
            console.log('result.message: ', result.message);
            dispatch(loginFail(result.message));
          }
        },
        // (e) => {
        //   console.log('e:::::::::;: ', e);
        //   // dispatch(loginFail(e.response?.data?.message));
        // }
      );
    } catch (error) {
      console.log('error.message: ', error.message);
      dispatch(loginFail(error.message));
    }
  };
};

export const signup = (formData) => {
  return (dispatch) => {
    try {
      dispatch(signupInit());
      Postdata(HttpService.signupUrl, formData).then(
        (result) => {
          if (result.status === 200) {
            console.log('result::::::::::: ', result);
            dispatch(signupSuccess(result));
          }
          else {
            toast.warning(result.message)
            return;
          }
        },
        (e) => {
          dispatch(signupFail(e.message));
        }
      );
    } catch (error) {
      dispatch(signupFail(error.message));
    }
  };
};

export const signupInit = () => ({
  type: types.SIGNUP_DATA,
});

// Signup success
export const signupSuccess = (data) => ({
  type: types.SIGNUP_DATA_SUCCESS,
  data,
});

// Signup failure
export const signupFail = (error) => ({
  type: types.SIGNUP_DATA_FAIL,
  data: error,
});

// Clear signup state
export const signupClear = () => ({
  type: types.SIGNUP_DATA_CLEAR,
});

export const verifyEmail = (data, onSuccess) => {
  return (dispatch) => {
    try {
      Postdata(HttpService.forgotPasswordUrl, data).then((response) => {
        if (response.status === 200) {

          dispatch(verifyEmailSuccess(response.data));
          dispatch(message(response.message || "Email verified successfully"));
          if (onSuccess) onSuccess(); // callback to redirect
        } else {

          dispatch(verifyEmailFail(response.message));
        }
      })
        .catch((error) => {
          console.log('response::::dddd: ', error);
          toast.error(error.response.data.message)
          // dispatch(verifyEmailFail());
        });
    } catch (error) {
      dispatch(verifyEmailFail(error.message));
    }
  };
};


export const otpVerify = (data, onSuccess) => {
  return (dispatch) => {
    try {
      Postdata(HttpService.verifyOtp, data).then((response) => {
        if (response.status === 200) {
          dispatch(verifyEmailSuccess(response.data));
          if (onSuccess) onSuccess(); // callback to redirect
        } else {
          dispatch(verifyEmailFail(response.message));
        }
      })
        .catch((error) => {
          dispatch(verifyEmailFail(error.message));
        });
    } catch (error) {
      dispatch(verifyEmailFail(error.message));
    }
  };
};

export const signUpotpVerify = (data, onSuccess) => {
  return (dispatch) => {
    try {
      Postdata(HttpService.verify_signUp_Otp, data).then((response) => {
        console.log('response: ', response);
        if (response.status === 200) {
          dispatch(verifyEmailSuccess(response.data));
          if (onSuccess) onSuccess(); // callback to redirect
        } else {
          dispatch(verifyEmailFail(response.message));
          console.log('response.message: ', response.message);
        }
      })
        .catch((error) => {
          console.log('error.message==>: ', error);
          dispatch(signupFail(error.response.data.message));
        });
    } catch (error) {
      dispatch(verifyEmailFail(error.message));
    }
  };
};

export const resetPasswordVerify = (data, onSuccess) => {
  return (dispatch) => {
    try {
      Postdata(HttpService.resetPasswordUrl, data).then((res) => {
        if (res.status === 200) {
          dispatch(resetPasswordSuccess(res.data));
          if (onSuccess) onSuccess(); // redirect callback
        } else {
          dispatch(resetPasswordFail(res.message));
        }
      })
        .catch((err) => {
          dispatch(resetPasswordFail(err.message));
        });
    } catch (error) {
      dispatch(verifyEmailFail(error.message));
    }
  };
};



export const loginInit = (data) => {
  return { type: types.LOGIN_DATA, data };
};

export const loginSuccess = (data) => {
  // Clear all localStorage to remove stale data from any previous school session
  window.localStorage.clear();
  window.sessionStorage.clear();
  // Now set the fresh token for the new login
  console.log("data",data.data)
  window.localStorage.setItem('activeSchoolId', data.data?.user?.school_id?._id);
  // window.localStorage.setItem('mode', data.data.token);
  window.localStorage.setItem('authorizationToken', data.data.token);
  // Note: The localStorage 'storage' event (set up in index.js) will automatically
  // notify other tabs about this change — no BroadcastChannel needed.
  return { type: types.LOGIN_DATA_SUCCESS, data };
};

export const loginOverride = (data) => {
  return { type: types.LOGIN_DATA_OVERRIDE, data };
};

export const loginFail = (data) => {
  // Only reset Redux state — don't touch localStorage.
  // A failed login attempt shouldn't invalidate an existing session in another tab.
  return { type: types.LOGIN_DATA_FAIL, data };
};

export const loginClear = (data) => {
  // Only reset Redux state — don't touch localStorage.
  // This is called on Login page mount. Removing the token here would trigger
  // a storage event in other tabs, causing a cascading logout loop.
  return { type: types.LOGIN_DATA_CLEAR, data };
};

export const loginForce = () => {
  window.localStorage.removeItem('authorizationToken');
  window.localStorage.removeItem('activeSchoolId');
  window.sessionStorage.clear();
  return window.location.href = '/';
};



export const verifyEmailInit = () => ({ type: types.VERIFY_EMAIL_INIT });
export const verifyEmailSuccess = (data) => ({
  type: types.VERIFY_EMAIL_SUCCESS,
  payload: data,
});
export const verifyEmailFail = (error) => {
  console.log('error:KKKKKKKK ', error);
  return ({
    type: types.VERIFY_EMAIL_FAIL,
    payload: error,
  });
};

export const otpVerifyInit = () => ({ type: types.OTP_VERIFY_INIT });
export const otpVerifySuccess = (data) => ({
  type: types.OTP_VERIFY_SUCCESS,
  payload: data,
});
export const otpVerifyFail = (error) => ({
  type: types.OTP_VERIFY_FAIL,
  payload: error,
});

export const resetPasswordInit = () => ({ type: types.RESET_PASSWORD_INIT });
export const resetPasswordSuccess = (data) => ({
  type: types.RESET_PASSWORD_SUCCESS,
  payload: data,
});
export const resetPasswordFail = (error) => ({
  type: types.RESET_PASSWORD_FAIL,
  payload: error,
});